<div class="body">
  <div class="container">
    <div class="row title-box">
      <div class="col-12 col-sm-12">
        <h3 class="txtbienvenida">Administración <span class="txtbienvenida-2">fecha y hora de suspensión</span></h3>
      </div>
    </div>
    <div class="row justify-content-end">
      <div class="col-12 col-sm-3 container-btn">
        <button type="button" [routerLink]="['crear']" class="btn btn-primary hvr-shrink">
          Crear parametrización
        </button>
      </div>
    </div>
    <div class="row pr-3 pl-3">
      <div class="table-responsive">
        <table class="table table-striped table-borderless rounded">
          <thead class="table_head">
            <tr>
              <th scope="col" class="no-styles table-header" id="fecha-incial">
                Fecha inicial
              </th>
              <th scope="col" class="no-styles table-header" id="fecha-final">
                Fecha final
              </th>
              <th scope="col" class="no-styles table-header" id="hora-inicial">
                Hora inicial
              </th>
              <th scope="col" class="no-styles table-header" id="hora-final">
                Hora final
              </th>
              <th scope="col" class="no-styles table-header" id="doc">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody>
            @for (horario of horariosSuspension | async; track horario) {
              <tr>
                <th scope="row" id="id-monto">{{ horario.fechaInicial |  date: "dd/MM/yyyy"}}</th>
                <td>{{ horario.fechaFinal |  date: "dd/MM/yyyy"}}</td>
                <td>{{ horario.horaInicial }}</td>
                <td>{{ horario.horaFinal}}</td>
                <td>
                  <button type="button" [routerLink]="['crear',horario.idSuspensionServicio]" id="btn-editar"
                    data-bs-toggle="modal" data-bs-target="#editModal"  class="hvr-shrink" data-bs-toggle="tooltip"
                    data-bs-placement="top" title="Editar">
                    <i class="fas fa-pencil-alt"></i>
                  </button>
                  <button type="button" id="btn-borrar" (click)="eliminarHorario(horario.idSuspensionServicio, horario.justificacion)"
                    class="hvr-shrink" data-bs-toggle="tooltip" data-bs-placement="top" title="Eliminar">
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-3 container-btn ">
        <button class="btn btn-primary hvr-shrink" style="width: 180px;" routerLink="/intermediario/home">
          Volver
        </button>
      </div>
    </div>
  </div>
  <div class="footer-body"></div>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
